// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__FLaEx","error":"Checkbox_error__wBDvu","indeterminate":"Checkbox_indeterminate__3jy1a","disabled":"Checkbox_disabled__DyvZl"};